import {inject} from 'vue';
import type {Toast} from '@/types/components/toast';
import {toastService} from '@/services/toastService';

export const ToastSymbol = Symbol('Toast');

export type ToastFunction = (props: Omit<Toast, 'id'>) => void;

export function useToast() {
    // Use a fallback function that matches the ToastFunction type
    const fallbackToast: ToastFunction = (props: Omit<Toast, 'id'>) => {
        toastService.show(props.type, props.title, props.message, props.duration);
    };

    // Inject with proper type-safe fallback
    return inject<ToastFunction>(ToastSymbol, fallbackToast);
}